export default __webpack_public_path__ + "static/media/DSC32006.2cb68c22.jpg";